var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSceLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 0H45.0882V43.75H0.324219V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 26.84L19.0462 28.434L5.36022 18.616L21.1122 24.226L5.94122 5.483L25.1152 20.146L19.3692 4.909L28.9242 17.851L28.0842 0L34.0842 17.914L38.5432 0H0.324219V37.295L18.8522 33.279L0.324219 26.84Z",
    fill: "#FFD046"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 37.288H38.5082V0H45.0872V43.778H0.324219V37.288Z",
    fill: "#006A53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.967 0.5H0.5V43.5H44.967V0.5Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceLogoMark);
export default __webpack_public_path__ + "static/media/SCELogoMark.6ac52847d5100288afde004499b1b1bb.svg";
export { ForwardRef as ReactComponent };